import { mapGetters, mapMutations } from 'vuex'

/** @todo When no city image used apply fallback image */
import CityImage from 'assets/images/cities/icons/city.svg'

import template from 'js/components/cities-select/list-layout/city-select/index.pug'

export default {
  name: 'list-city-select',
  template: template(),
  props: {
    municipalityItem: {
      type: Object,
      required: true
    },
    showDescription: false
  },
  
  computed: {
    image() {
      return this.municipalityItem.image_url || CityImage
    },

    name() {
      return this.municipalityItem.valid_name_for_client
    },

    description() {
      return this.municipalityItem.description_for_client
    },

    highlighted() {
      return this.municipalityItem.highlighted
    },

    nameNormalized() {
      return this.municipalityItem.name_normalized
    },

    country() {
      return this.municipalityItem.country_alpha2
    }
  },

  methods: {
    ...mapMutations('municipality', ['setMunicipality']),

    goToCity() {
      // devDump('goToCity', this.municipalityItem)
      this.setMunicipality(this.municipalityItem)
      sessionStorage.setItem('municipality-id', this.municipalityItem.id)
      this.$router.push({
        name: 'municipality',
        params: {
          country: this.country, 
          municipality: this.municipality
        }
      })
    }
  }
}
